import React, { useEffect, useState } from "react";
import {
  Container,
  Box,
  Grid,
  Paper,
  styled,
  CircularProgress,
  Typography,
} from "@mui/material";
import { useParams } from "react-router-dom";
import CurrentStatus from "./CurrentStatus";
import ProjectDetails from "./ProjectDetails";
import ProgressTimeline from "./ProgressTimeline";
import RecentActivity from "./RecentActivity";
import { getClientData } from "../services/clientService";
import ContactNowCard from "./ContactNowCard";
import Header from "./Header";
import { trackVisit } from "../services/analyticsService";

export default function Main({ darkMode, setDarkMode }) {
  const { clientId } = useParams();
  const [clientData, setClientData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!clientId) {
      setError(true);
      setLoading(false);
      return;
    }

    setLoading(true);
    getClientData(clientId)
      .then((data) => {
        if (!data || Object.keys(data).length === 0) {
          setError(true);
        } else {
          setClientData(data);
          trackVisit({
            clientId,
            pageUrl: window.location.pathname,
          });
        }
      })
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, [clientId]);
  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="80vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="80vh"
      >
        <Typography variant="h6" color="textSecondary">
          No client found. Please check the Client ID in the URL.
        </Typography>
      </Box>
    );
  }
  return (
    <>
    <Header
        darkMode={darkMode}
        setDarkMode={setDarkMode}
        clientName={clientData["Full Name"]}
        createdAt = {clientData["Created At"]}
      />
    <Container
      maxWidth={false}
      sx={(theme) => ({
        px: { xs: 2, sm: 3, md: 4 },
        backgroundColor:
          theme.palette.mode === "light"
            ? "#f9fafb"
            : theme.palette.background.default, // adapts to dark mode
      })}
    >
      <Box pt={4}>
        <Grid container spacing={3}>
          {/* Left column - Current Status */}
          <Grid size={{ xs: 12, md: 8 }}>
            <CurrentStatus status={clientData["status"]} />
          </Grid>
          <Grid size={{ xs: 12, md: 4 }}>
            <ProjectDetails
              fullName={clientData["Full Name"]}
              startDate={clientData["Created At"]}
              businessType={clientData["Business Type"]}
            />
          </Grid>
        </Grid>
      </Box>
      <Box mt={4} mb={4}>
        <Grid container spacing={3}>
          {/* Left column - Current Status */}
          <Grid size={{ xs: 12, md: 8 }}>
            <ProgressTimeline currentStatus={clientData["status"]} />
          </Grid>
          <Grid size={{ xs: 12, md: 4 }}>
            <ContactNowCard />
          </Grid>
        </Grid>
      </Box>
    </Container>
    </>
  );
}
